import dynamic from 'next/dynamic';

import { Link } from '@natu/next-link';
import { type ButtonProps } from '@natu/ui/Button';
import type { PredefinedGAEvents } from '@natu/utils/events';

import { type StoryblokLink, getLinkPropsFromStoryblok } from '../../../../../utils';

const Button = dynamic(() => import('@natu/ui/Button').then(mod => mod.Button));

const ButtonWithEvent = dynamic(() =>
  import('@natu/ui/Button/ButtonWithEvent').then(mod => mod.ButtonWithEvent),
);

interface SBNavigationButtonProps {
  link?: StoryblokLink;
  label?: string;
  hasEvent?: boolean;
  isMobile?: boolean;
}

export const NavigationButton = ({ link, label, hasEvent, isMobile }: SBNavigationButtonProps) => {
  const linkProps = getLinkPropsFromStoryblok(link);

  if (!link || !label) return null;

  const buttonProps = {
    asChild: true,
    size: 'md',
    variant: 'primary',
    className: isMobile ? 'mt-10 w-full py-[9px] font-semibold' : 'hidden py-[7px] lg:inline-flex',
  } as ButtonProps;

  const eventProps = {
    event: 'E_cta_to_form' as PredefinedGAEvents,
    eventProps: {
      event_cta_position: 'nav',
      event_cta_section: 'nav',
    },
  };

  if (hasEvent)
    return (
      <ButtonWithEvent {...eventProps} {...buttonProps}>
        <Link {...linkProps}>{label}</Link>
      </ButtonWithEvent>
    );

  return (
    <Button {...buttonProps}>
      <Link {...linkProps}>{label}</Link>
    </Button>
  );
};
